var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      (_vm.user.practice.status !== 1 && _vm.user.force_password_change) ||
      !_vm.user.practice.is_setup_complete ||
      !_vm.user.practice.phone ||
      !_vm.user.practice.address
    )?_c('confirm-practice-modal'):(_vm.$route.name === 'referral-view' && _vm.$route.query.e && _vm.$route.query.e === _vm.$route.params.id)?_c('ViewingExampleReferralModal'):_vm._e(),(!_vm.user.practice.is_public)?_c('upsell-modal'):_vm._e(),(_vm.activeTour)?_c('referral-tour',{attrs:{"name":_vm.activeTour}}):_vm._e(),(_vm.$store.getters['sms/isVisible'])?_c('sms'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }